import { makeStyles } from "@mui/styles";
import { SwipeableList, SwipeableListItem } from "@sandstreamdev/react-swipeable-list";
import { Draggable, Droppable } from "react-beautiful-dnd";

import ContentTypeItem from "./ContentTypeItem";
import { TAB_STATUSES } from "../../../../constants";
import { EyeClosed, EyeNormal } from "../../../../icons";
import { DraggableStyles } from "../../../containers/DraggableStyles";
import SwipeWrapper from "../../../containers/SwipeWrapper";

const useStyles = makeStyles({
  sortTableTagList: {
    "& button": {
      "& span": {
        "& svg": {
          marginRight: "0.5rem",
          color: "#fff",
        },
      },
    },
  },
  eyeIcons: {
    fontSize: "1.6rem",
    marginRight: "calc(.5rem + 3px)",
  },
  droppable: {
    paddingTop: "8px",
  },
});

export default function SortedContentTypes(props) {
  const {
    tabStatus,
    filteredContentTypes,
    onChangeTypeStatus,
    primaryFilter,
    typeFilterId,
    tagFilterId,
    gridView,
    filteredContentTypeMediaItems = {},
    locked,
  } = props;

  const classes = useStyles();

  const Wrapper = ({ children, condition, wrapper }) => (condition ? wrapper(children) : children);

  const ContentTypeItemComponent = ({
    contentType,
    index,
    snapshotDraggable = "",
    primaryFilter,
    typeFilterId,
    tagFilterId,
    gridView,
    filteredContentTypeMediaItems,
  }) => {
    return (
      <ContentTypeItem
        contentType={contentType}
        index={index}
        tabStatus={tabStatus}
        onChangeTypeStatus={onChangeTypeStatus}
        snapshotDraggable={snapshotDraggable}
        primaryFilter={primaryFilter}
        typeFilterId={typeFilterId}
        tagFilterId={tagFilterId}
        gridView={gridView}
        filteredContentTypeMediaItems={filteredContentTypeMediaItems}
        locked={locked}
      />
    );
  };

  return (
    <div className={classes.droppable} data-testid="sorted-content-types-container">
      <Droppable droppableId="droppableTypes" isDropDisabled={tabStatus !== TAB_STATUSES.CUSTOMIZE || locked}>
        {(provided) => (
          <div {...provided.droppableProps} ref={provided.innerRef} className={classes.sortTableTagList}>
            {filteredContentTypes.map((contentType, index) => {
              return (
                <div key={`type-list-${contentType.id}`}>
                  {!contentType.hidden && (
                    <Draggable
                      draggableId={`type-list-${contentType.name}`}
                      index={index}
                      isDragDisabled={contentType.hidden || tabStatus !== TAB_STATUSES.CUSTOMIZE}
                      disableInteractiveElementBlocking={false}
                    >
                      {(providedDraggable, snapshotDraggable) => {
                        const currentlyDragged =
                          providedDraggable &&
                          providedDraggable.dragHandleProps &&
                          providedDraggable.dragHandleProps["data-rbd-drag-handle-draggable-id"];

                        const getStyleResults = DraggableStyles(
                          providedDraggable.draggableProps,
                          contentType.hidden,
                          () => onChangeTypeStatus(contentType, index),
                        );

                        const isCurrentlyDragged =
                          snapshotDraggable.isDragging && currentlyDragged === `type-list-${contentType.name}`;

                        return (
                          <Wrapper
                            condition={tabStatus === TAB_STATUSES.CUSTOMIZE}
                            wrapper={(children) => (
                              <SwipeWrapper
                                icon={
                                  contentType.hidden ? (
                                    <EyeNormal className={classes.eyeIcons} />
                                  ) : (
                                    <EyeClosed className={classes.eyeIcons} />
                                  )
                                }
                                opacity={getStyleResults.swipeOpacity}
                                zIndex={isCurrentlyDragged ? "2" : "0"}
                              >
                                {children}
                              </SwipeWrapper>
                            )}
                          >
                            <div
                              ref={providedDraggable.innerRef}
                              {...providedDraggable.draggableProps}
                              {...providedDraggable.dragHandleProps}
                              style={{
                                ...getStyleResults,
                                zIndex: isCurrentlyDragged ? "3" : "1",
                              }}
                            >
                              <ContentTypeItemComponent
                                contentType={contentType}
                                index={index}
                                snapshotDraggable={snapshotDraggable}
                                primaryFilter={primaryFilter}
                                typeFilterId={typeFilterId}
                                tagFilterId={tagFilterId}
                                gridView={gridView}
                                filteredContentTypeMediaItems={filteredContentTypeMediaItems}
                              />
                            </div>
                          </Wrapper>
                        );
                      }}
                    </Draggable>
                  )}
                </div>
              );
            })}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
      {tabStatus === TAB_STATUSES.CUSTOMIZE && (
        <div className={classes.sortTableTagList} style={{ width: "240px" }}>
          {filteredContentTypes.map((contentType, index) => (
            <div key={`hidden-type-list-${contentType.name}`}>
              {contentType.hidden && (
                <SwipeableList>
                  <SwipeableListItem
                    swipeLeft={{
                      content: contentType.hidden ? (
                        <EyeNormal className={classes.eyeIcons} />
                      ) : (
                        <EyeClosed className={classes.eyeIcons} />
                      ),
                      action: () => {
                        onChangeTypeStatus(contentType, index);
                      },
                    }}
                  >
                    <ContentTypeItemComponent contentType={contentType} index={index} />
                  </SwipeableListItem>
                </SwipeableList>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
